import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

export const Project = {
  state: {
    project: {}
  },
  mutations: {
    setProject (state, payload) {
      state.project = {...payload}
    },
    addUser (state, payload) {
      state.project.projectUsersFeData.push(payload)
    },
    removeUser (state, payload) {
      state.project.projectUsersFeData = _.filter(state.project.projectUsersFeData, user => {
        return user.id !== payload
      })
    }
  },
  actions: {
    addUserToProject ({ commit }, payload) {
      commit('addUser', payload)
    },

    removeUserFromProject ({ commit }, payload) {
      commit('removeUser', payload)
    },

    updateProject ({ commit }, payload) {
      commit('setProject', payload)
    },

    updateProjectProperties ({ commit, getters }, payload) {
      commit('setProject', _.assign(getters.getProject, payload))
    },

    clearProject ({ commit, dispatch }) {
      dispatch('clearActiveTasks')
      dispatch('clearArchiveTasks')
      dispatch('clearCustomTasks')
      dispatch('clearSortTask')
      dispatch('clearTasksDragDisabled')
      dispatch('closeCreateTask')
      return commit('setProject', {})
    }
  },
  getters: {
    getActiveProjectUsers (state) {
      let activeProjectUsers = _.filter(state.project.projectUsersFeData, ['userActiveOnProject', true])
      return _.orderBy(activeProjectUsers, function (user) {
        return user.userProjectRole === 'owner' ? 0 : 1;
      });
    },

    getProjectUsers (state) {
      return state.project.projectUsersFeData
    },

    getCountProjectDesigners (state, getters) {
      const designers = getters.getProjectUsers.filter(user => user.role === 'designer')
      return designers.length
    },

    getPotentialProjectOwners (state) {
      return _.filter(state.project.projectUsersFeData, user => {
        return user.userActiveOnProject === true && user.role === 'customer'
      })
    },

    getProject (state) {
      return state.project
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Project.js